import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from 'react';
const CircleXIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M12.5 23.4375C6.45939 23.4375 1.5625 18.5406 1.5625 12.5C1.5625 6.45939 6.45939 1.5625 12.5 1.5625C18.5406 1.5625 23.4375 6.45939 23.4375 12.5C23.4375 18.5406 18.5406 23.4375 12.5 23.4375ZM12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: color
  }), __jsx("path", {
    d: "M7.26007 7.26007C7.56517 6.95498 8.05983 6.95498 8.36493 7.26007L12.5 11.3951L16.6351 7.26007C16.9402 6.95498 17.4348 6.95498 17.7399 7.26007C18.045 7.56517 18.045 8.05983 17.7399 8.36493L13.6049 12.5L17.7399 16.6351C18.045 16.9402 18.045 17.4348 17.7399 17.7399C17.4348 18.045 16.9402 18.045 16.6351 17.7399L12.5 13.6049L8.36493 17.7399C8.05983 18.045 7.56517 18.045 7.26007 17.7399C6.95498 17.4348 6.95498 16.9402 7.26007 16.6351L11.3951 12.5L7.26007 8.36493C6.95498 8.05983 6.95498 7.56517 7.26007 7.26007Z",
    fill: color
  }));
};
export default CircleXIcon;